// Components
import { Link, LicenseCategoryIcon, IconPublicDomainCircle, Tooltip, IconSyncCircle } from '@tracklib/kit'

// Types
import { LicenseInfo as LicenseInfoType } from 'types'
import styles from './licenseinfo.css'

type LicenseInfoProps = {
  licenseInfo: LicenseInfoType
  displayAsRow?: boolean
}

const LicenseInfo = ({ licenseInfo, displayAsRow }: LicenseInfoProps): JSX.Element => (
  <div className={displayAsRow ? styles.displayAsRow : undefined}>
    <Link to="/licensing/#revenueshare">
      Category
      <LicenseCategoryIcon priceCategory={licenseInfo.license_price_category} />
    </Link>
    {!licenseInfo.allow_sync && (
      <div data-tooltip-wrapper>
        <Link href="https://support.tracklib.com/hc/en-us/articles/360009945219" target="_blank" datatesting="song_categoryfooter">
          <IconSyncCircle className={styles.licenseIcon} />
        </Link>
        <Tooltip>
          <span>Sync on request</span>
        </Tooltip>
      </div>
    )}
    {(licenseInfo.public_domain || licenseInfo.spoken_word) && (
      <div data-tooltip-wrapper>
        <Link href="https://support.tracklib.com/hc/en-us/articles/360009859180" target="_blank" datatesting="song_categoryfooter">
          <IconPublicDomainCircle className={styles.licenseIcon} />
        </Link>
        <Tooltip>
          <span>No original publisher</span>
        </Tooltip>
      </div>
    )}
  </div>
)

export default LicenseInfo
